import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, programId) => {
    axios
      .get(routes.api.programs.show(programId))
      .then((response) => {
        dispatch({ type: 'LOAD', program: response.data.data });
      });
  },
  prepareNewProgram: (dispatch, countSessions, programId) => {
    axios
      .get(routes.api.members.newProgram, { params: { sessions_count: countSessions, program_id: programId } })
      .then((response) => {
        dispatch({ type: 'LOAD', program: response.data.data });
      });
  },
  prepareNewAiProgram: (dispatch, countSessions) => {
    axios
      .get(routes.api.members.newAiProgram, { params: { sessions_count: countSessions } })
      .then((response) => {
        dispatch({ type: 'LOAD', program: response.data.data });
      });
  },
  updateProgramSession: (dispatch, countSessions) => {
    axios
      .post(routes.api.members.createProgram, { sessions_count: countSessions })
      .then((response) => {
        dispatch({ type: 'LOAD', program: response.data.data });
      });
  },
  updateTopic: (dispatch, stepId, topicId, callback) => {
    axios
      .post(routes.api.steps.updateTopic(stepId), {
        topic_id: topicId,
      })
      .then((resp) => {
        dispatch({ type: 'UPDATE_STEP', stepId, step: resp.data.data });
        callback();
      });
  },
  completeStep: (dispatch, stepId, callback) => {
    axios
      .post(routes.api.members.steps.complete(stepId))
      .then((resp) => {
        dispatch({ type: 'UPDATE_STEP', stepId, step: resp.data.data.attributes });
        callback();
      });
  },
  updateStep: (dispatch, stepId, data) => {
    dispatch({ type: 'UPDATE_STEP', stepId, step: data });
  },
  updateTitle: (dispatch, programId, title, callback) => {
    axios
      .patch(routes.api.members.updateProgram(programId), { title })
      .then(() => {
        dispatch({ type: 'UPDATE_TITLE', title });
        callback();
      });
  },
  updateCoach: (dispatch, programId, coachId, callback) => {
    axios
      .patch(routes.api.members.updateProgram(programId), { coach_id: coachId })
      .then((response) => {
        dispatch({ type: 'LOAD', program: response.data.data });
        callback();
      });
  },
  sendChangeCoachRequest: (dispatch, values, programId, successCallback, errorCallback) => {
    axios
      .post(routes.api.change_coach_requests.create, {
        workType: 'CoachingPlanChangeCoach',
        description: values.reason,
        coachingPlanId: programId,
      })
      .then(() => {
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data.error);
      });
  },
};
